import { useState } from 'react';
import { useFlags } from 'src/feature-flags/FlagsHook';
import type { CalendarEvent } from 'src/meetings/models';
import { useRegenerateMeetingArtifacts } from './useRegenerateMeetingArtifacts';

// An attendee change can leave the summary and the documents built from the recording naming the
// wrong people, so offer to regenerate whichever of them already exist.
export const useRegenerateAfterAttendeeChange = (meeting: CalendarEvent | null | undefined) => {
  const { flagEnabledAttendeeChangesRefreshOutputs } = useFlags();
  const { artifacts, regenerate, isRegenerating } = useRegenerateMeetingArtifacts(meeting);
  const [opened, setOpened] = useState(false);

  const onAttendeesChanged = () => {
    if (flagEnabledAttendeeChangesRefreshOutputs && artifacts.length > 0) {
      setOpened(true);
    }
  };

  const onConfirm = async () => {
    await regenerate();
    setOpened(false);
  };

  return {
    onAttendeesChanged,
    regenerateModalProps: {
      opened,
      onClose: () => setOpened(false),
      onConfirm,
      artifacts,
      isRegenerating,
    },
  };
};
